import React from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import AdminLayout from "./layouts/Admin/AdminLayout"
import MainLayout from "./layouts/Main/MainLayout"
import Home from "./pages/Home"
import FlightsForm from "./pages/Flights"
import BookingForm from "./pages/Booking"
import Calendar from "./components/Calendar"
import Success from "./pages/Success"
import Summary from "./pages/Summary"
import PaymentForm from "./pages/Payment"
import Dashboard from "./pages/Admin/Dashboard"
import { AuthProvider } from './contexts/AuthContext'
import { DataProvider } from './contexts/DataContext'
// import { CollectJSProvider, injectCollectJS } from "@lydiagoulding/react-nmi-collectjs"

import ProtectedRoute from './components/ProtectedRoute'
import AdminLogin from './pages/Admin/Login'

import './App.css'

// const collectJS = injectCollectJS('https://secure.networkmerchants.com/token/Collect.js', 'vmW88H-743KY5-eXNm4z-Z4477a')

const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        {/* <CollectJSProvider collectJSPromise={collectJS}> */}
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route element={<DataProvider><MainLayout /></DataProvider>}>
              <Route index element={<Home />} />
              <Route path="/flight-form" element={<FlightsForm />} />
              <Route path="/booking-form" element={<BookingForm />} />
              <Route path="/summary" element={<Summary />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/success" element={<Success />} />
              <Route path="/payment" element={<PaymentForm />} />
            </Route>

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={
              <ProtectedRoute>
                <DataProvider>
                  <AdminLayout>
                    <Dashboard />
                  </AdminLayout>
                </DataProvider>
              </ProtectedRoute>
            } />
          </Routes>
        </Router>
        {/* </CollectJSProvider> */}
      </AuthProvider>
    </QueryClientProvider>
  )
}

export default App
